/**
 * Decode browser-escaped native letters for CMS lookup and seed identity.
 * Preserve reserved escapes, case and trailing slashes; do not rewrite history.
 */
export function decodeLandingRequestPath(path: string): string {
  try { return decodeURI(path); }
  catch { return path; }
}
